import { gql } from 'graphql-request'

export const QueryFormattedTextBlock = gql`
  fragment FragmentFormattedTextBlock on FormattedTextBlockModelRecord {
    __typename
    id
    icon
    content {
      value
    }
    anchor
  }
`
